import { jsx as _jsx } from "react/jsx-runtime";
import { Box, Typography } from "@mui/material";
import React from "react";
import { actionMotionStyles } from "../micro-interactions/actionMotion";
import { ButtonStyle } from "./style";
import { black500 } from "../../../constants/color";
export const PrimaryButon = ({ children, motion = false, disabled, onClick, mt = 0, mb = 0, type = "button", }) => {
    // Prevent onClick when disabled
    const handleClick = (e) => {
        if (disabled) {
            e.preventDefault(); // Prevent click when disabled
            return;
        }
        if (onClick) {
            onClick(); // Trigger onClick if not disabled
        }
    };
    return (_jsx(Box, { component: "button", onClick: handleClick, width: "100%", mb: mb, type: type, sx: {
            ...ButtonStyle,
            ...(motion ? actionMotionStyles : {}),
            mt: `${mt}px`,
            background: disabled ? "#FFEAB2" : "#FFBC00",
            border: disabled ? "1px solid #FFBC00" : "none",
            cursor: disabled ? "not-allowed" : "pointer",
        }, disabled: disabled, children: _jsx(Typography, { sx: { whiteSpace: "nowrap" }, variant: "subtitle2", color: black500, children: children }) }));
};
